import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  IconButton,
  Typography,
  Divider,
  Tooltip,
  Stack,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { motion, AnimatePresence } from "framer-motion";
import SidebarItem from "./SidebarItem";
import auth from "../auth/authService";
import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { LogoutSharp } from "@mui/icons-material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { useColorMode } from "./ColorModeContext";

export const SIDEBAR_OPEN_WIDTH = 260;
export const SIDEBAR_COLLAPSED_WIDTH = 70;



export default function Sidebar({
  onToggle,
  user,
  mobileOpen,
  onMobileClose }) {



  const navigate = useNavigate();



  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isDark = theme.palette.mode === "dark";
  const [open, setOpen] = useState(() => {
    return localStorage.getItem("sidebar-open") === "false" ? false : true;
  });
  const sidebarExpanded = isMobile ? true : open;

  const { toggleColorMode } = useColorMode();

  useEffect(() => {
    if (isMobile) return; // 🔥 STOP TOTAL DI MOBILE

    onToggle?.(
      open ? SIDEBAR_OPEN_WIDTH : SIDEBAR_COLLAPSED_WIDTH
    );
  }, [open, isMobile, onToggle]);


  useEffect(() => {
    if (!isMobile) {
      onMobileClose?.();
    }
  }, [isMobile, onMobileClose]);

  // useEffect(() => {
  //   console.log("Theme mode:", theme.palette.mode);

  // }, [theme.palette.mode]);

  // useEffect(() => {

  //   console.log("Sidebar mounted");
  //   return () => console.log("Sidebar unmounted");
  // }, []);

  const handleLogout = () => {
    auth.logout();
    navigate("/login");
  };


  const toggle = () => {
    const newOpen = !open;
    setOpen(newOpen);
    localStorage.setItem("sidebar-open", newOpen);

    if (!isMobile) {
      onToggle?.(
        newOpen ? SIDEBAR_OPEN_WIDTH : SIDEBAR_COLLAPSED_WIDTH
      );
    }
  };

  const menu = [
    { title: "Dashboard", icon: "Dashboard", path: "/dashboard" },
    {
      title: "Master Data",
      icon: "Folder",
      children: [
        {
          title: "Anggota Betania",
          icon: "People",
          path: "/memberbetania"
        },
        {
          title: "Tambah Anggota Betania",
          icon: "PersonAdd",
          path: "/newmember"
        },
        { title: "Jemaat", icon: "MenuBook", path: "/jemaat" },
        { title: "Proses Awal Tahun", icon: "FlagCircle", path: "/billinggenerator" },
      ],
    },
    { title: "Pembayaran", icon: "ReceiptLong", path: "/paymenttransact" },
    { title: "Historis Transaksi", icon: "ReceiptLong", path: "/paymenthistory" },
    {
      title: "Laporan", icon: "Assignment", path: "/unpaid",
      children: [
        {
          title: "Transaksi Harian",
          icon: "Today",
          path: "/reports/dailytransactions"
        },
        {
          title: "Summary Cash", icon: "BarChart",
          path: "/reports/cash_summary"
        },
        {
          title: "", icon: "WarningAmber",
          path: "/reports/unpaid_billing"
        },
      ],

    },
  ];

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={isMobile ? mobileOpen : open}
      onClose={isMobile ? onMobileClose : undefined}
      ModalProps={{
        keepMounted: true,
      }}
      slotProps={{
        paper: {
          component: motion.div,
          initial: false,
          animate: {
            width: isMobile
              ? SIDEBAR_OPEN_WIDTH
              : open
                ? SIDEBAR_OPEN_WIDTH
                : SIDEBAR_COLLAPSED_WIDTH,
          },
          transition: { duration: 0.3 },
          sx: {
            width: isMobile
              ? SIDEBAR_OPEN_WIDTH
              : open
                ? SIDEBAR_OPEN_WIDTH
                : SIDEBAR_COLLAPSED_WIDTH,

            background: isDark
              ? "linear-gradient(180deg, rgba(15,23,42,0.98), rgba(2,6,23,0.95))"
              : "linear-gradient(180deg, rgba(248,250,252,0.98), rgba(226,232,240,0.96))",
            color: isDark ? "#f8fafc" : "#0f172a",
            borderRight: `1px solid ${isDark ? alpha("#ffffff", 0.08) : "#e2e8f0"}`,
            // boxShadow: open
            //   ? "0 0 20px rgba(180,0,255,.35)"
            //   : "0 0 10px rgba(180,0,255,.2)",
            overflowX: "hidden",
            backdropFilter: "blur(14px)",
          },
        },
      }}
    >


      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          justifyContent: sidebarExpanded ? "space-between" : "center",

        }}
      >
        <AnimatePresence>
          {sidebarExpanded && (
            <motion.div
              initial={{ opacity: 0, x: -15 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -15 }}
              transition={{ duration: 0.25 }}
            >
              <Stack direction="column" spacing={0} alignItems="center">
                <Stack direction="row" spacing={0} alignItems="center">
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      letterSpacing: 1,
                      background: "linear-gradient(90deg,#38bdf8,#2563eb)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Betania
                  </Typography>
                  <Typography variant="h5"
                    sx={{
                      fontWeight: 700,
                      letterSpacing: 1,
                      background:
                        isDark ? "#cbd5f5" : "#0f172a",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}>Hub</Typography>

                </Stack>
                {/* <Typography sx={{ color: '#ffffff' }}  > Ukuran {isMobile ? "Mobile" : "Desktop"}</Typography> */}
              </Stack>

            </motion.div>
          )}
        </AnimatePresence>

        <Tooltip title={open ? "Collapse" : "Expand"}>
          <IconButton
            onClick={isMobile ? onMobileClose : toggle}
            sx={{ color: isDark ? "#f8fafc" : "#0f172a" }}
          >
            <MenuIcon />
          </IconButton>

        </Tooltip>
      </Box>

      <Divider sx={{ borderColor: isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0" }} />

      {/* MENU */}
      <Box sx={{ p: 1, pt: 2 }}>
        {menu.map((m, i) => (
          // <SidebarItem key={i} item={m} sidebarOpen={open} level={0} />
          <SidebarItem
            key={i}
            item={m}
            sidebarOpen={sidebarExpanded}
            level={0}
            onItemClick={isMobile ? onMobileClose : undefined}
          />

        ))}
      </Box>


      <Box sx={{ flexGrow: 1 }} />
      {/* THEME TOGGLE */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={sidebarExpanded ? "center" : "center"}
        sx={{ p: 1 }}
      >
        {/* {sidebarExpanded && (
          <Typography fontSize={13} sx={{ mr: 1 }}>
            Toggle Theme
          </Typography>
        )} */}
        <IconButton onClick={toggleColorMode} color="inherit">
          {theme.palette.mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
      </Stack>


      <Divider sx={{ borderColor: isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0" }} />


      {/* FOOTER */}
      <Box
        sx={{
          p: 2,
          display: "flex",
          flexDirection: sidebarExpanded ? "row" : "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >




        <Tooltip title="Logout">
          <Box
            onClick={handleLogout}
            sx={{
              cursor: "pointer",
              width: sidebarExpanded ? 260 : 44,
              height: 44,
              mx: "auto",
              borderRadius: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1.5,
              color: isDark ? "#f87171" : "#b91c1c",
              border: `1px solid ${isDark ? "rgba(248,113,113,.35)" : "rgba(185,28,28,.35)"}`,
              transition: "all .25s ease",
              "&:hover": {
                background: isDark ? "rgba(248,113,113,.15)" : "rgba(185,28,28,.08)",
                boxShadow: isDark
                  ? "0 0 14px rgba(248,113,113,.35)"
                  : "0 0 10px rgba(185,28,28,.15)",
              },
            }}
          >

            <LogoutSharp />

            {sidebarExpanded && (
              <Typography fontSize={13} fontWeight={600}>
                Logout
              </Typography>
            )}
          </Box>
        </Tooltip>


      </Box>


    </Drawer>
  );
}
